import { OurProjects } from './OurProjects';

export default OurProjects;
